// Case studies slider: infinite, 1 card, 2 from 1025px (same as infuse.com/programs)
import Swiper from 'swiper/bundle';

export default function caseStudies() {
  const slider = document.querySelector('.case-studies__slider');
  if (!slider) return;

  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 20,
    // Swiper 11 loop needs slides >= slidesPerView + slidesPerGroup: 3 cards cover 2 per view, 1 per step
    loop: true,
    grabCursor: true,
    pagination: {
      el: '.case-studies__pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.case-studies__arrow--next',
      prevEl: '.case-studies__arrow--prev',
    },
    breakpoints: {
      1025: {
        slidesPerView: 2,
      },
    },
  });
}
